<template>
  <div>
    <div class="modal show fade modal-danger text-left" style="display: block;" v-if="show">
      <div class="modal-dialog modal-lg" style="max-width: 80%;">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">Others Details</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="card">
              <div v-if="!isEmpty(list) && list.other_details" class="card-body ">
                <p><strong>Comments: </strong> {{ list.other_details ? list.other_details.comments : 'N/A' }}</p>
              </div>
              <div class="card-body text-center text-primary" v-else>
                No Details Avaliable
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-danger" data-dismiss="modal" @click="$emit('hide')">Close</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>

export default {
  props: ['show', 'data', 'index'],
  data() {
    return {
      list: [],
      accordionToShow : -1
      // showModal: false,
    }
  },
  mounted() {
    // this.list = this.data
  },
  methods: {
    setupData() {
    }
  },
  watch: {
    show() {
      this.list = this.data
    },
  }
}
</script>

<style scoped>
.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  height: 70vh;
  overflow-y: auto;
}
</style>

